export class SessionIdBase {
    FCT;
    constructor(FCT) {
        this.FCT = FCT;
    }
}
//# sourceMappingURL=SessionIdBase.js.map